/**
 * Date formats available to users as display preference.
 *
 * @namespace tmrUserDateFormats
 * @type {ngConstant}
 */
export const constant = [
  'tmrUserDateFormats',
  ['shortDate', 'short', 'medium', 'mediumMilliseconds'],
]
